import _ from 'lodash'

/**
 * Converts the value of shapeTextProperty (eg `budget-spent`) to the
 * corresponding showX property name (eg `showBudgetSpent`)
 */
function showPropertyToTextProperty (showProperty) {
	if (_.isEmpty(showProperty)) {
		return null
	}
	return _.kebabCase(showProperty.replace('show', ''))
}

export default showPropertyToTextProperty

showPropertyToTextProperty.__filename__ = 'dashboards/widgets/shape/show-property-to-text-property.js'
